import React, { ReactElement } from 'react';
import ImageData from '@ax2/common/model/schemas/ImageDataSchema';
import styles from '../../styles/components/questions/QuestionEntity.module.css';
import parse from 'html-react-parser';
import { fetchImage } from '../../rest/surveyClient';
import Loading from '@ax2/common/components/Loading';

export interface QuestionEntityData {
  question: string;
  helperText?: string;
  number?: string;
  answerElement: ReactElement;
  imageUrl: ImageData | null;
}

const QuestionEntity: React.FC<QuestionEntityData> = data => {
  const [imageSrc, setImageSrc] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    async function fetchImageData() {
      if (data.imageUrl && data.imageUrl.Key) {
        setLoading(true);
        try {
          const imgKey = data.imageUrl.Key.replace(/^.*?\//, '');
          const imgData = await fetchImage(imgKey);
          const imgUrlData = URL.createObjectURL(imgData);
          setImageSrc(imgUrlData);
        } catch (error) {
          console.log('Error fetching image Data', error);
          setLoading(false);
        } finally {
          setLoading(false);
        }
      }
    }
    fetchImageData();
  }, [data.imageUrl]);

  const helperText = data.helperText;
  return (
    <div className={styles.questionElementContainer}>
      <span className={styles.title}>
        {data.number && `${data.number}.`} {parse(data.question)}
      </span>
      {imageSrc ? (
        <img className={styles.imgPreview} src={imageSrc} alt="preview image" />
      ) : null}
      {data.imageUrl && data.imageUrl.Key && !imageSrc && loading ? (
        <Loading paddingVertical={150} />
      ) : null}
      {helperText && <span className={styles.helperText}>{helperText}</span>}
      <div
        className={
          helperText ? styles.offsetAnswerWrapper : styles.answerWrapper
        }
      >
        {data.answerElement}
      </div>
    </div>
  );
};

export default QuestionEntity;
